import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Panel } from "@/components/kmt/ui";
import { RideForm } from "@/components/kmt/RideForm";
import { useOwnerApi } from "@/lib/api";
import { PageTitle } from "./DashLayout";

export default function NewBooking() {
  const api = useOwnerApi();
  const nav = useNavigate();
  return (
    <div className="max-w-4xl">
      <PageTitle title="Add a ride" sub="For phone or in-person bookings. The ride goes into the inbox as Requested." />
      <Panel>
        <RideForm owner submitLabel="Add ride" onSubmit={async (p) => {
          const r = await api.post("/bookings", p);
          toast.success(`Ride ${r.data.ref} added`);
          nav(`/dashboard/bookings/${r.data.id}`);
        }} />
      </Panel>
    </div>
  );
}
